import { v4 as uuidv4 } from 'uuid'
import { EducationRoute } from '@/modules/education/v1/api/EducationRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { CreateQuestionParams } from '@/modules/education/v1/api/v1/questions/Dto/CreateQuestionParams'
import { QuestionUuid } from '@/modules/education/v1/api/v1/questions/Dto/QuestionUuid'

/** POST /api/education/v1/questions: создать вопрос; 201 {uuid} */
export class CreateQuestionRoute extends EducationRoute<CreateQuestionParams, QuestionUuid> {
  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/education/v1/questions'
  }

  offline(): Promise<ApiResponse<QuestionUuid>> {
    return Promise.resolve(new ApiResponse({ success: true, data: new QuestionUuid({ uuid: uuidv4() }) }))
  }
}
